export interface ProductMeta {
  taxonomies: Taxonomies;
  productLearnMoreImageUrls: string[];
  consciousChoices: ConsciousChoice[];
  ingredientBenefits: IngredientBenefit[];
  productUsageInstruction: string;
}

export interface Taxonomies {
  skinType: SkinType[];
  skinConcern: SkinConcern[];
  efficacy: Efficacy[];
  starIngredient: StarIngredient[];
  sensitiveIngredient: SensitiveIngredient[];
}

export interface SkinType {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface SkinConcern {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface Efficacy {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface StarIngredient {
  efficacyDescription: string;
  version: number;
  efficacy: string;
  risk: string;
  engName: string;
  updateAt: string;
  ingredientSlug: string;
  korName: string;
  description: string;
  ingredientName: string;
}

export interface SensitiveIngredient {
  efficacyDescription: string;
  version: number;
  efficacy: string;
  risk: string;
  engName: string;
  updateAt: string;
  ingredientSlug: string;
  korName: string;
  description: string;
  ingredientName: string;
}

export interface ConsciousChoice {
  id: number;
  title: string;
  description: string;
}

export interface IngredientBenefit {
  benefit: Benefit;
  ingredients: Ingredient[];
}

export interface Benefit {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface Ingredient {
  termId: number;
  name: string;
  slug: string;
  impact: string;
  description: string;
  ewgRate: number;
}
